import { render, staticRenderFns } from "./SettlementType.vue?vue&type=template&id=dfc8d774&"
import script from "./SettlementType.vue?vue&type=script&lang=js&"
export * from "./SettlementType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports